import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../../api/Constants';
import { validateJson } from '../../../utils/jsonschema/validator';
import { assetsPackageRequestDataSuccess } from '../../slices/assetsPackage/assetsPackage';
import imagePreload from '../../../utils/imagePreload';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
var endpoint = Endpoints.ASSETS;
export var getAssetsPackageQuery = {
  query: function query(_ref) {
    var assetsPackageId = _ref.assetsPackageId;
    return {
      url: "".concat(endpoint, "/").concat(assetsPackageId)
    };
  },
  providesTags: ['AssetsPackage'],
  transformResponse: function transformResponse(response) {
    if (validateJson(endpoint, response)) return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, _ref2) {
      var dispatch, queryFulfilled, getState, _yield$queryFulfilled, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch = _ref2.dispatch, queryFulfilled = _ref2.queryFulfilled, getState = _ref2.getState;
              _context2.prev = 1;
              _context2.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled = _context2.sent;
              data = _yield$queryFulfilled.data;
              dispatch(assetsPackageRequestDataSuccess(data.assetsPackage));
              Object.values(getState().assetsPackage.assets).forEach( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return imagePreload(item, data.assetsPackage);

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              handleQueryLoggerEvents(_context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 10]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};